import React, { FC } from 'react';
import { PictureProps } from '../Picture';
import { LinkProps } from '../Link';
import { Icons } from '../Icon';
import * as SC from './styled';
export type RecipeIngredientProps = {
  className?: string;
  amount: string;
  name: string;
  product?: {
    name: string;
    image?: PictureProps;
    linkProps?: LinkProps;
  };
};
const RecipeIngredient: FC<RecipeIngredientProps> = props => {
  const {
    className,
    name,
    amount,
    product
  } = props;
  return <SC.Item className={className}>
      <SC.Wrapper>
        <SC.AmountTag>
          <SC.Amount>{amount}</SC.Amount>
        </SC.AmountTag>
        <SC.Name>{name}</SC.Name>
      </SC.Wrapper>
      {product && <SC.Product {...product?.linkProps}>
          {product?.image && <SC.ProductImage {...product?.image} />}
          <SC.ProductName>{product?.name}</SC.ProductName>
          {product.linkProps && <SC.Arrow icon={Icons.arrowRight} />}
        </SC.Product>}
    </SC.Item>;
};
export default RecipeIngredient;